import { ContactUserListRequestModel } from "../business-entities/contact-user-details-view-model";
import { ContactUserDataService } from "../data-services/contact-user-data.service";
import { Injectable } from "@angular/core";
import { GenericResponse } from "../../../../Autofacets-Core/src/app/business-entities/generic-response.class";

@Injectable({
    providedIn: 'root'
})
export class ContactUserService {
    contactUserListRequest: ContactUserListRequestModel =
        {
            searchTerm: '',
            startRecordNumber: 0,
            pageSize: 25,
            sortColumn: '',
            sortDirection: '',
            isForDocuments: false
        }

    constructor(private service: ContactUserDataService) {
    }
    async getContactUserList(requestModel: ContactUserListRequestModel): Promise<GenericResponse<any>> {
        return this.service.getContactUserList(requestModel);
    }
}